<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Weitere Verpackungseinheiten löschen' | translate }}</div>
  <dx-switch [(value)]="deleteAdditionalPackings"></dx-switch>
</div>
